"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var AdminRemindersController = /** @class */ (function () {
    function AdminRemindersController(UserService, RemindersModel, FlashService, $sce) {
        var _this = this;
        this.UserService = UserService;
        this.RemindersModel = RemindersModel;
        this.FlashService = FlashService;
        this.$sce = $sce;
        this.loading = true;
        this.reminders = [];
        this.page_by = 10;
        this.totalItems = 0;
        this.currentPage = 0;
        this.RemindersModel.getReminders(this.UserService.getCurrentUser().school_id, { page_by: this.page_by, page: this.currentPage }).then(function (response) {
            _this.reminders = response.reminders.data;
            _this.currentPage = response.reminders.current_page;
            _this.totalItems = response.reminders.total;
            _this.loading = false;
        });
    }
    AdminRemindersController.prototype.formatDriveDate = function (drive) {
        return (0, time_1.dateTimeStringToDate)(drive.drive_date + " " + drive.start_time).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };
    AdminRemindersController.prototype.pageChanged = function () {
        var _this = this;
        this.loading = true;
        this.RemindersModel.getReminders(this.UserService.getCurrentUser().school_id, { page_by: this.page_by, page: this.currentPage }).then(function (response) {
            _this.reminders = response.reminders.data;
            _this.currentPage = response.reminders.current_page;
            _this.totalItems = response.reminders.total;
            _this.loading = false;
        });
    };
    AdminRemindersController.prototype.deleteReminder = function (id) {
        var _this = this;
        this.loading = true;
        this.RemindersModel.deleteReminder(this.UserService.getCurrentUser().school_id, id)
            .then(function (response) {
            _this.reminders = _this.reminders.filter(function (reminder) { return reminder.id !== id; });
            _this.loading = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function (error) {
            _this.loading = false;
            _this.FlashService.setMessage({
                type: "error",
                message: error.message,
            });
        });
    };
    AdminRemindersController.prototype.formatReminderType = function (type) {
        return type.toUpperCase();
    };
    AdminRemindersController.prototype.formatEmailContent = function (html) {
        return this.$sce.trustAsHtml(html);
    };
    AdminRemindersController.prototype.formatDate = function (dateString) {
        if (!dateString) {
            return "";
        }
        return (0, time_1.formatDateTime)(dateString, "MM/DD/YYYY h:mm a");
    };
    return AdminRemindersController;
}());
AdminRemindersController.$inject = [
    "UserService",
    "RemindersModel",
    "FlashService",
    "$sce",
];
exports.default = AdminRemindersController;
